
import { AnalyticsCore } from './core';
import { EventCategories } from './constants';

/**
 * Events related to user journey through the application
 */
export class UserJourneyEvents extends AnalyticsCore {
  /**
   * Track when a user selects a category
   */
  trackCategorySelect(categoryId: string, categoryName: string) {
    this.trackEvent({
      category: EventCategories.NAVIGATION,
      action: 'category_select',
      label: categoryName,
      dimensions: {
        category_id: categoryId,
        category_name: categoryName
      }
    });
  }

  /**
   * Track search actions
   */
  trackSearch(searchTerm: string, resultsCount: number) {
    this.trackEvent({
      category: EventCategories.SEARCH,
      action: 'search',
      label: searchTerm,
      value: resultsCount,
      dimensions: {
        search_term: searchTerm,
        results_count: resultsCount
      }
    });
  }

  /**
   * Track how far users are scrolling
   */
  trackScrollDepth(percentage: number, path?: string) {
    // Only track at meaningful thresholds to avoid excessive events
    if (percentage % 25 === 0 || percentage === 100) {
      this.trackEvent({
        category: EventCategories.ENGAGEMENT,
        action: 'scroll_depth',
        label: path || window.location.pathname,
        value: percentage,
        nonInteraction: true,
        dimensions: {
          scroll_percentage: percentage,
          path: path || window.location.pathname
        }
      });
    }
  }

  /**
   * Track return visits
   */
  trackReturnVisit(userId?: string, daysInactive?: number) {
    this.trackEvent({
      category: EventCategories.USER,
      action: 'return_visit',
      label: userId || 'anonymous',
      value: daysInactive,
      dimensions: {
        days_inactive: daysInactive,
        user_id: userId || 'anonymous'
      }
    });
  }
  
  /**
   * Track authentication events
   */
  trackAuthEvent(eventType: 'sign_up' | 'sign_in' | 'sign_out', method: string, userId?: string) {
    this.trackEvent({
      category: EventCategories.USER,
      action: eventType,
      label: method,
      dimensions: {
        auth_method: method,
        user_id: userId || this.userId || 'anonymous'
      }
    });
  }
}
